import { formatTextFloat, formatValueBillion } from '../../../helpers/Text';
import ConstTooltip from '../../../common/mixTable/tooltip/Const';

const listColumn = [
  {
    key: 'ticker',
    typeTooltip: ConstTooltip.typeHover.hoverScore,
    textAlign: 'left',
    isIconGraph: true,
    keyOrgCode: 'organCode',
    isUsingCellHover: false,
    isString: true,
  },
  {
    key: 'ranking',
    textAlign: 'right',
    isRanking: true,
    keyRank: 'icbRank',
    keyTotalRank: 'icbTotalRanked',
    width: '70px',
    thTooltip: 'table.strategy.ranking',
    valueFromItem: item => {
      return item.icbRank + item.ticker;
    },
  },
  {
    key: 'icbName',
    textAlign: 'left',
    isDisSort: true,
    isDropDown: true,
    isString: true,
  },
  {
    key: 'rtd11',
    format: value => formatTextFloat(formatValueBillion(value), 2),
    textAlign: 'right',
  },
  {
    key: 'value',
    isString: true,
    typeTooltip: ConstTooltip.typeHover.hoverValueScore,
    isSetColorText: true,
    textAlign: 'center',
    keyOrgCode: 'organCode',
    keyTicker: 'ticker',
    thTooltip: 'table.strategy.value',
  },
  {
    key: 'growth',
    isString: true,
    typeTooltip: ConstTooltip.typeHover.hoverValueScore,
    isSetColorText: true,
    textAlign: 'center',
    keyOrgCode: 'organCode',
    keyTicker: 'ticker',
    thTooltip: 'table.strategy.growth',
  },
  {
    key: 'momentum',
    isString: true,
    typeTooltip: ConstTooltip.typeHover.hoverValueScore,
    isSetColorText: true,
    textAlign: 'center',
    keyOrgCode: 'organCode',
    keyTicker: 'ticker',
    tooltipHeight: 190,
    thTooltip: 'table.strategy.momentum',
  },
  {
    key: 'vgm',
    isString: true,
    isSetColorText: true,
    textAlign: 'center',
    keyOrgCode: 'organCode',
    keyTicker: 'ticker',
    thTooltip: 'table.strategy.vgm',
  },
];

const itemAllIndustries = {
  icbName: 'All Industries',
  icbCode: 'all',
};

const fetchDataSortKeys = [
  'rtd11',
  'ranking',
  'ticker',
  'value',
  'growth',
  'momentum',
  'vgm',
];

export default {
  fetchDataSortKeys,
  listColumn,
  organCode: 'organCode',
  maxRowData: 10,
  itemAllIndustries,
};
